import React from "react";
import { PACE_RANGES, getPaceRangeDisplayLabel } from "../../constants/clubConstants";
import { useConsolePaceUnit } from "../../hooks/useConsolePaceUnit";
import { PACE_PILLS_MAX } from "../../utils/consoleRunsConstants";

/** Render pace range pills (optional, max 2). selectedValues = array of PACE_RANGES value; onPacesChange(newArray). */
export default function ConsolePaceRangePills({ selectedValues, onPacesChange }) {
  const { unit: paceUnit } = useConsolePaceUnit();
  const current = Array.isArray(selectedValues) ? selectedValues : [];
  return (
    <div className="flex flex-wrap gap-2">
      {PACE_RANGES.map((r) => {
        const selected = current.includes(r.value);
        return (
          <button
            key={r.value}
            type="button"
            onClick={() => {
              if (selected) {
                onPacesChange(current.filter((v) => v !== r.value));
              } else if (current.length < PACE_PILLS_MAX) {
                onPacesChange([...current, r.value].slice(0, PACE_PILLS_MAX));
              }
            }}
            className={`px-3 py-1.5 rounded-full text-sm border ${
              selected
                ? "bg-[var(--console-accent)] text-white border-[var(--console-accent)]"
                : "border-[var(--console-border)] bg-[var(--console-surface)] text-[var(--console-ink)] hover:border-[var(--console-muted)]"
            }`}
          >
            {getPaceRangeDisplayLabel(r, paceUnit)}
          </button>
        );
      })}
    </div>
  );
}
